import React, { useEffect, useState } from "react";
import Footer from "../main/Footer";
import { API } from "../../API";
import { Container, Row, Col, Card, Form, Alert } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";
import axios from "axios";

const TopActivity = () => {
  const [analytics, setAnalytics] = useState({
    totalVisitors: 0,
    mostVisitedPages: [],
    searchTrends: [],
    sessionDuration: 0,
  });
  const [filters, setFilters] = useState({
    channel: "",
    videoTitle: "",
    month: "",
    date: "",
  });

  const [totalVisitors, setTotalVisitors] = useState(0);
  const [mostVisitedPages, setMostVisitedPages] = useState([]);
  const [searchTrends, setSearchTrends] = useState([]);

  const [sessionDuration, setSessionDuration] = useState(0);
  //
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const [
  //         visitors,
  //         pages,
  //         searches,
  //         act,
  //         daily,
  //         browsers,
  //         devices,
  //         countries,
  //         session,
  //       ] = await Promise.all([
  //         axios.get(`${API}/api/analytics/total-visitors`),
  //         axios.get(`${API}/api/analytics/most-visited`),
  //         axios.get(`${API}/api/analytics/search-trends`),
  //         axios.get(`${API}/api/analytics/activity`),

  //         axios.get(`${API}/api/analytics/session-duration`),
  //       ]);
  //       console.log("visitors.data", visitors.data);
  //       console.log("pages.data", pages.data);
  //       console.log("Top Searches", searches.data);

  //       setTotalVisitors(visitors.data.totalVisitors);
  //       setMostVisitedPages(pages.data);
  //       setSearchTrends(searches.data);
  //       setSessionDuration(session.data.avgDuration);
  //     } catch (error) {
  //       console.error("Error fetching analytics data", error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        console.log("Fetching analytics data with filters:", filters);

        const [visitorsRes, pagesRes, searchesRes, sessionRes] =
          await Promise.all([
            axios.get(`${API}/api/analytics/total-visitors`, {
              params: filters,
            }),
            axios.get(`${API}/api/analytics/most-visited`, { params: filters }),
            axios.get(`${API}/api/analytics/search-trends`, {
              params: filters,
            }),
            axios.get(`${API}/api/analytics/session-duration`, {
              params: filters,
            }),
          ]);

        console.log("Most Visited Pages Data:", pagesRes.data);

        // **Apply Filtering in Frontend**
        let filteredPages = pagesRes.data;

        if (filters.channel) {
          filteredPages = filteredPages.filter((item) =>
            item._id.toLowerCase().includes(filters.channel.toLowerCase())
          );
        }

        if (filters.videoTitle) {
          filteredPages = filteredPages.filter((item) =>
            item._id.toLowerCase().includes(filters.videoTitle.toLowerCase())
          );
        }

        setAnalytics({
          totalVisitors: visitorsRes.data.totalVisitors || 0,
          mostVisitedPages: filteredPages.map((item) => ({
            pageTitle: item._id,
            count: item.count,
          })),
          searchTrends: searchesRes.data || [],
          sessionDuration: sessionRes.data.avgDuration || 0,
        });

        setError(null);
      } catch (err) {
        console.error("Error fetching analytics data:", err);
        setError("Failed to load analytics data. Please try again.");
      }
    };

    fetchAnalytics();
  }, [filters]);

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <Container className="py-4">
            <h2 className="text-center mb-4">📊 Analytics Dashboard</h2>

            {error && <Alert variant="danger">{error}</Alert>}

            <Row className="g-4">
              <Col md={6}>
                <Card className="p-3 text-white bg-primary">
                  <h4>Total Visitors</h4>
                  <h2>{analytics.totalVisitors}</h2>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="p-3 text-dark bg-warning">
                  <h4>Avg. Session Duration</h4>
                  <h2>{analytics.sessionDuration.toFixed(2)} sec</h2>
                </Card>
              </Col>
            </Row>

            <Row className="my-3">
              {/* Filter by Channel */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Filter by Channel</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter channel name"
                    value={filters.channel}
                    onChange={(e) =>
                      setFilters({ ...filters, channel: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>

              {/* Filter by Video Title */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Filter by Video Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter video title"
                    value={filters.videoTitle}
                    onChange={(e) =>
                      setFilters({ ...filters, videoTitle: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>

              {/* Filter by Month */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Filter by Month</Form.Label>
                  <Form.Control
                    type="month"
                    value={filters.month}
                    onChange={(e) =>
                      setFilters({ ...filters, month: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>

              {/* Filter by Date */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Filter by Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={filters.date}
                    onChange={(e) =>
                      setFilters({ ...filters, date: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Charts Layout */}
            <Row className="mt-4">
              <Col lg={12} sm={12}>
                <h4>📌 Most Visited Pages</h4>
                <BarChart
                  width={1200}
                  height={400}
                  data={analytics.mostVisitedPages}
                >
                  <XAxis dataKey="pageTitle" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#0088FE" />
                </BarChart>
              </Col>
              {/* <Col lg={6} sm={12}>
                <h4>🔍 Top Search Trends</h4>
                <BarChart
                  width={500}
                  height={300}
                  data={analytics.searchTrends}
                >
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#FFBB28" />
                </BarChart>
              </Col> */}
            </Row>
          </Container>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TopActivity;
